<page-data-manager>
  <div class="ibox">
    <div class="ibox-title">
      <div class="ibox-tools">
        <button type="button"
                class="btn btn-primary"
                ng-disabled="ie.createNew"
                ng-click="ie.createNew = true"
                ng-if="$root.permissions.itens_estoque.canManage">
          Novo
          <i class="fa fa-plus"></i>
        </button>
      </div>
      <h2>Itens de estoque</h2>
    <div class="ibox-content border-bottom m-b-sm">
      <!-- New item -->
      <edit-stock-item ng-show="ie.createNew"
                       products="ie.products"
                       groups="ie.groups"
                       atividades="ie.atividades"
                       units="ie.units"></edit-stock-item>

      <!-- Search box -->
      <form ng-submit="ie.searchItems()" class="row">
        <div class="col-xs-12">
          <h3>Filtrar</h3>
        </div>
        <div class="col-xs-4 form-group">
          <input type="search" name="descricao" id="descricao" ng-model="ie.search.descricao" class="form-control" placeholder="Nome">
        </div>
        <div class="col-xs-3 form-group">
          <ui-select name="grupo" id="grupo" ng-model="ie.search.grupo">
            <ui-select-match placeholder="Grupo de insumos">{{$select.selected.descricao | capitalize}}</ui-select-match>
            <ui-select-choices repeat="group in ie.groups | filter: $select.search">
              <span ng-bind-html="group.descricao | capitalize | highlight: $select.search"></span>
            </ui-select-choices>
          </ui-select>
        </div>
        <div class="col-xs-3 form-group">
          <select name="exibir" id="exibir" class="form-control" ng-model="ie.search.exibir">
            <option value="all">Todos</option>
            <option value="ativos">Apenas ativos</option>
            <option value="inativos">Apenas inativos</option>
          </select>
        </div>
        <div class="col-xs-2">
          <div class="btn-group">
            <button type="submit" class="btn btn-success">
              <i class="fa fa-search"></i>
            </button>
            <button type="button" class="btn btn-white" ng-if="ie.isFiltering()" title="Limpar filtros" ng-click="ie.clearFilters()">
              <i class="fa fa-times"></i>
            </button>
          </div>
        </div>
      </form>

      <!-- Pagination -->
      <div class="text-right">
        <pagination walk="ie.setPage(page)" pages="ie.pages"></pagination>
      </div>
    </div>

    <!-- Loader -->
    <p class="text-cinza preloader text-center" ng-show="ie.loading">
      <i class="fa fa-spinner fa-pulse fa-fw text-cinza"></i> Carregando...
    </p>

    <!-- List -->
    <p class="ibox-content padding" ng-if="!ie.loading && !ie.items.length">
      Nenhum item encontrado.
    </p>
    <div class="faq-item" ng-repeat="item in ie.items track by $index" data-index="{{$index}}">
      <div class="row">
        <div ng-class="ie.columnClass()">
          <a class="faq-question" ng-click="ie.openEdit($index)">
            {{item.descricao}}
            <i class="fa fa-pencil" ng-if="$root.permissions.itens_estoque.canManage"></i>
            <i class="glyphicon glyphicon-eye-open" ng-if="$root.permissions.itens_estoque.canRead && !$root.permissions.itens_estoque.canManage"></i>
          </a>
          <small>
            <span class="text-muted">#{{item.item_id}}</span>&nbsp;&nbsp;
            <span ng-repeat="classificacao in item.classificacoes_humanize">{{classificacao}}<br></span>
          </small>
        </div>
        <div ng-class="ie.columnClass()">
          <span class="small font-bold">Grupo de insumos</span> <br>
          {{item.grupo.descricao | capitalize}}

          <button
            type="button"
            class="btn btn-link btn-sm pull-right"
            uib-tooltip="{{item.ativo ? 'Desativar' : 'Ativar'}}"
            ng-click="ie.toggleItem(item)"
            ng-if="!$root.permissions.estoque.canViewStock"
          >
            <i class="fa" ng-class="{
              'fa-square-o': !item.ativo,
              'fa-check-square-o': item.ativo
            }"></i>
          </button>
        </div>
        <div ng-class="ie.columnClass()" ng-if="$root.permissions.estoque.canViewStock">
          <span class="small font-bold">Estoque físico / em uso / receber</span> <br>
          {{ie.getItemBalance(item)}}

          <button
            type="button"
            ng-if="$root.permissions.itens_estoque.canManage"
            class="btn btn-link btn-sm pull-right"
            uib-tooltip="{{item.ativo ? 'Desativar' : 'Ativar'}}"
            ng-click="ie.toggleItem(item)"
          >
            <i class="fa" ng-class="{
              'fa-square-o': !item.ativo,
              'fa-check-square-o': item.ativo
            }"></i>
          </button>
        </div>
      </div>
      <div class="row">
        <edit-stock-item item="item"
                         products="ie.products"
                         groups="ie.groups"
                         atividades="ie.atividades"
                         units="ie.units"
                         ng-if="$root.permissions.itens_estoque.canRead && item.edit"></edit-stock-item>
      </div>
    </div>

    <div class="ibox-content text-right" ng-if="ie.items.length && ie.pages.numbers.length && !ie.loading">
      <pagination walk="ie.setPage(page)" pages="ie.pages"></pagination>
    </div>
  </div>
</page-data-manager>
